/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "select": {
      "loading": "Loading",
      "noMatch": "No matching data",
      "noData": "No data",
      "placeholder": "Select",
      "showOptions": "Show options",
      "hideOptions": "Hide options"
    }
  },
  "de-DE": {
    "select": {
      "loading": "Laden",
      "noMatch": "Keine passenden Daten",
      "noData": "Keine Daten",
      "placeholder": "Auswählen",
      "showOptions": "Optionen anzeigen",
      "hideOptions": "Optionen ausblenden"
    }
  },
  "es-ES": {
    "select": {
      "loading": "Cargando",
      "noMatch": "No hay datos que coincidan",
      "noData": "Sin datos",
      "placeholder": "Seleccionar",
      "showOptions": "Mostrar opciones",
      "hideOptions": "Ocultar opciones"
    }
  },
  "fr-FR": {
    "select": {
      "loading": "Chargement",
      "noMatch": "Aucune donnée correspondante",
      "noData": "Aucune donnée",
      "placeholder": "Sélectionner",
      "showOptions": "Afficher les options",
      "hideOptions": "Masquer les options"
    }
  },
  "id-ID": {
    "select": {
      "loading": "Memuat",
      "noMatch": "Tidak ada data yang cocok",
      "noData": "Tidak ada data",
      "placeholder": "Pilih",
      "showOptions": "Tampilkan opsi",
      "hideOptions": "Sembunyikan opsi"
    }
  },
  "it-IT": {
    "select": {
      "loading": "Caricamento",
      "noMatch": "Nessun dato corrispondente",
      "noData": "Nessun dato",
      "placeholder": "Seleziona",
      "showOptions": "Mostra opzioni",
      "hideOptions": "Nascondi opzioni"
    }
  },
  "jp-JP": {
    "select": {
      "loading": "読み込み中",
      "noMatch": "一致するデータがありません",
      "noData": "データなし",
      "placeholder": "選択",
      "showOptions": "オプションを表示",
      "hideOptions": "オプションを非表示"
    }
  },
  "ko-KO": {
    "select": {
      "loading": "로드 중",
      "noMatch": "일치하는 데이터 없음",
      "noData": "데이터 없음",
      "placeholder": "선택",
      "showOptions": "옵션 표시",
      "hideOptions": "옵션 숨기기"
    }
  },
  "nl-NL": {
    "select": {
      "loading": "Bezig met laden",
      "noMatch": "Geen overeenkomende gegevens",
      "noData": "Geen gegevens",
      "placeholder": "Selecteren",
      "showOptions": "Opties weergeven",
      "hideOptions": "Opties verbergen"
    }
  },
  "pl-PL": {
    "select": {
      "loading": "Wczytywanie",
      "noMatch": "Brak pasujących danych",
      "noData": "Brak danych",
      "placeholder": "Wybierz",
      "showOptions": "Pokaż opcje",
      "hideOptions": "Ukryj opcje"
    }
  },
  "pt-PT": {
    "select": {
      "loading": "Carregando",
      "noMatch": "Sem dados correspondentes",
      "noData": "Sem dados",
      "placeholder": "Selecione",
      "showOptions": "Mostrar opções",
      "hideOptions": "Ocultar opções"
    }
  },
  "ru-RU": {
    "select": {
      "loading": "Загрузка",
      "noMatch": "Нет подходящих данных",
      "noData": "Нет данных",
      "placeholder": "Выбрать",
      "showOptions": "Показать параметры",
      "hideOptions": "Скрыть параметры"
    }
  },
  "tr-TR": {
    "select": {
      "loading": "Yükleniyor",
      "noMatch": "Eşleşen veri yok",
      "noData": "Veri yok",
      "placeholder": "Seç",
      "showOptions": "Seçenekleri göster",
      "hideOptions": "Seçenekleri gizle"
    }
  },
  "vi-VN": {
    "select": {
      "loading": "Đang tải",
      "noMatch": "Không có dữ liệu phù hợp",
      "noData": "Không có dữ liệu",
      "placeholder": "Chọn",
      "showOptions": "Hiển thị các tùy chọn",
      "hideOptions": "Ẩn tùy chọn"
    }
  },
  "zh-CN": {
    "select": {
      "loading": "正在载入",
      "noMatch": "无匹配数据",
      "noData": "无数据",
      "placeholder": "选择",
      "showOptions": "显示选项",
      "hideOptions": "隐藏选项"
    }
  },
  "zh-TW": {
    "select": {
      "loading": "載入中",
      "noMatch": "無相符資料",
      "noData": "無資料",
      "placeholder": "選取",
      "showOptions": "顯示選項",
      "hideOptions": "隱藏選項"
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
